export default "__VITE_ASSET__9YDz41Hf__"